module.exports = __webpack_public_path__ + "img/down-sx3.b7fd7b62.png";